import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { LecturerRateDisplayType } from '../../../../../api/types/lecturers/price-rate/lecturer-rate-display-type';
import { RequestRateType } from '../../../../../api/types/lecturers/price-rate/request-rate/request-rate-type';
import globalUserPage from '../../../../../stores/global-user-page';
import { UserDetailsLecturerRes } from '../../../../../api/types/lecturers/user-details-lecturer';
import { hasOverlap } from './rate-has-overlap-operations';
import { FileUploadFile } from 'primereact/fileupload';
import { uploadDocFileAndRetrieveUrlOperation } from '../../../pages/docs/componenets/operations/upload-doc-file-and-retrieve-url-operation';
import { LegalEntityType } from '../componenets/acountant/user-page-lecturer-rate-accountant';
import { Nullable } from 'primereact/ts-helpers';

export const addPriceRateForLecturerOperations = async (
  branchId: number | undefined,
  lecturerId: number,
  priceRateTypeId: number | undefined,
  requestDescription: string,
  price: number,
  lecturerRateDisplayType: LecturerRateDisplayType | null,
  startDate: Nullable<Date>,
  endDate: Nullable<Date>,
  docName: string,
  docFile: FileUploadFile | undefined,
  travel: number | undefined,
  abstractCourseIds: number[],
  legalEntityType: LegalEntityType | null,
  onHide: () => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    if (isNaN(Number(branchId))) {
      toast.warn('תחילה יש לוודא את הסניף המבוקש');
      return;
    }

    if (isNaN(Number(priceRateTypeId))) {
      toast.warn('יש לבחור את סוג התמחור');
      return;
    }
    if (isNaN(Number(price)) || price <= 0) {
      toast.warn('יש להזין מחיר תקין');
      return;
    }

    if (lecturerRateDisplayType === null) {
      toast.warn('יש לבחור סוג תצוגה');
      return;
    }

    if (!abstractCourseIds || abstractCourseIds.length === 0) {
      toast.warn('יש לבחור לפחות קורס אחד');
      return;
    }

    if (!startDate || !endDate) {
      toast.warn('יש להזין תאריך התחלה וסיום');
      return;
    }

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      toast.warn('יש להזין תאריך תקין');
      return;
    }

    if (
      hasOverlap(
        globalUserPage.lecturerDetails!.rates3,
        branchId,
        priceRateTypeId,
        startDate,
        endDate,
      )
    ) {
      toast.warn('לא ניתן ליצור בקשה לתאריכים חופפים');
      return;
    }

    if (!legalEntityType) {
      toast.warn('יש לבחור סוג יישות');
      return;
    }

    if (docName.length < 3 || !docFile) {
      toast.warn('יש לצרף קובץ');
      return;
    }
    console.log(`File name: ${docName}`);
    console.log(`File exist: ${!!docFile}`);

    setLoading(true);

    // TODO upload image
    const fileUrl = await uploadDocFileAndRetrieveUrlOperation(
      docFile!,
      lecturerId,
    );

    const res = await appApi.addRequestRatingPriceRateForLecturer(
      branchId!,
      lecturerId,
      priceRateTypeId!,
      requestDescription,
      price,
      lecturerRateDisplayType!,
      startDate!,
      endDate!,
      RequestRateType.New,
      docName,
      fileUrl,
      '',
      travel,
      abstractCourseIds,
      legalEntityType!,
    );

    setLoading(false);

    const newRateRes: UserDetailsLecturerRes = res.data.body;
    globalUserPage.lecturerDetails = newRateRes;

    toast.success('הפעולה בוצעה בהצלחה');
    onHide();
  } catch (e) {
    setLoading(false);
    console.error(
      `addPriceRateForLecturerOperations is failed with the error: ${e}`,
    );
    toast.error('הפעולה נכשלה, נסה שוב בעוד מספר רגעים');
  }
};
